<template>
  <b-container
    class="content main_header bgr bgl"
    style="background-color: #dbe0da"
    fluid=""
  >
    <Main_nav />
    <b-row class="div_content">
      <!--      <b-col>-->
      <!--        <img-->
      <!--          src="../assets/images/background/leaf_left.svg"-->
      <!--          style="position: absolute; bottom: 11%; left: 0"-->
      <!--        />-->
      <!--      </b-col>-->
      <b-col class="content bg">
        <p class="title-1">ธนาคารความหลากหลายทางชีวภาพระดับชุมชน</p>
        <p class="title-2">COMMUNITY BIOBANK</p>
        <!--        <img-->
        <!--          src="../assets/images/logo/logo_community_biobank.svg"-->
        <!--          height="250px"-->
        <!--          width="250px"-->
        <!--        />-->
        <b-row>
          <b-col class="">
            <div class="table d-flex justify-content-center">
              <table
                style="border-top: 0px !important"
                cellspacing="0"
                cellpadding="0"
              >
                <tr>
                  <td rowspan="2">
                    <img
                      height="58px"
                      class="mx-auto"
                      src="../assets/icons/icons_general/icon_place.svg"
                    />
                  </td>
                  <td>
                    <b
                      class="font-title"
                      style="color: #db7f50; font-size: 32px"
                    >
                      {{ this.overview.community }} </b
                    ><br />
                    <p class="font-body">ชุมชน</p>
                  </td>
                  <td rowspan="2">
                    <img
                      height="58px"
                      class="mx-auto"
                      src="../assets/icons/icons_general/icon_leaf.svg"
                    />
                  </td>
                  <td>
                    <b
                      class="font-title"
                      style="color: #41634a; font-size: 32px"
                      >{{ this.overview.plants }}</b
                    ><br />
                    <p class="font-body">ชนิดพืช</p>
                  </td>
                  <td rowspan="2">
                    <img
                      height="58px"
                      class="mx-auto"
                      src="../assets/icons/icons_general/icon_bee.svg"
                    />
                  </td>
                  <td>
                    <b
                      class="font-title"
                      style="color: #41634a; font-size: 32px"
                      >0</b
                    ><br />
                    <p class="font-body">ชนิดสัตว์</p>
                  </td>
                  <td rowspan="2">
                    <img
                      height="58px"
                      class="mx-auto"
                      src="../assets/icons/icons_general/icon_mushroom.svg"
                    />
                  </td>
                  <td>
                    <b
                      class="font-title"
                      style="color: #41634a; font-size: 32px"
                      >0</b
                    ><br />
                    <p class="font-body">ชนิดเห็ด</p>
                  </td>
                </tr>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="d-flex justify-content-center"
            xl="2"
            offset-xl="5"
            lg="4"
            offset-lg="4"
            md="4"
            offset-md="4"
            cols="8"
            offset="2"
          >
            <b-button
              class="btn btn-block"
              pill
              style="background-color: #3b5286; color: white"
              @click="gotoSearch"
            >
              <b-icon-search></b-icon-search>
              ค้นหาพืช
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <!--      <b-col>-->
      <!--        <img-->
      <!--          src="../assets/images/background/leaf_right.svg"-->
      <!--          style="position: absolute; bottom: 11%; right: 0"-->
      <!--        />-->
      <!--      </b-col>-->
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Main_nav from "@/components/navbar";
import { mapState } from "vuex";
export default {
  name: "main_header",
  components: { Main_nav },
  created() {
    this.$store.dispatch("viewModule/onGetOverview");
  },
  computed: {
    ...mapState({
      overview: (state) => state.viewModule.overview,
    }),
  },
  methods: {
    gotoSearch() {
      this.$router.push("/Search");
    },
  },
};
</script>
<style lang="scss">
.div_content {
  position: absolute;
  //top: 15%;
  width: 100%;
  height: 100%;
}
.main_header {
  //min-height: 85vh;
  min-height: 550px;
}
.main_header {
  background-image: url("../assets/bg.png");
  background-size: 100% auto;
  background-position: 0 100%;
  background-repeat: no-repeat;
}

@media only screen and (max-width: 400px) {
  .main_header {
    background-size: revert;
    background-repeat: no-repeat;
  }
}
.content {
  display: block;
  position: relative;
}
.title-1 {
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #41634a;
}
p.title-2 {
  font-style: normal;
  font-weight: 500;
  font-size: 48px;
  line-height: 72px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  background: -webkit-linear-gradient(
    rgba(0, 0, 0, 1),
    rgba(130, 130, 130, 1),
    rgba(0, 0, 0, 1)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
